import React, { useCallback, useContext, useRef } from 'react';
import classnames from 'classnames';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import LazyContext from '../LazyLoadingImage/LazyContext';
import { useSliderOverflow } from './hooks/useSliderOverflow';
import { useSliderScrollToIndex } from './hooks/useSliderScrollToIndex';
import { useSliderScrollHandler } from './hooks/useSliderScrollHandler';
import DefaultPreviousButton from './lego/DefaultPreviousButton';
import DefaultNextButton from './lego/DefaultNextButton';
import s from './Slider.scss';
const Slider = ({ smoothInitialScroll = true, scrollBy = 0.5, scrollSnap, className, height, children, disableScroll, slimSpacing, noSpacing, permArrows, dataHook, contentClassName, disableArrows, renderNextButton, renderPrevButton, scrollToIndex, onScrollBiData, enableMobileSwipeLogging, stableWidthButtons })=>{
    const rootRef = useRef(null);
    const contentRef = useRef(null);
    const isMobile = useContext(MobileContext);
    const overflow = useSliderOverflow(contentRef);
    const handleScrollBtnClick = useSliderScrollHandler(contentRef, scrollBy, onScrollBiData, enableMobileSwipeLogging);
    useSliderScrollToIndex(contentRef, rootRef, scrollToIndex, smoothInitialScroll);
    const withControls = !isMobile && !disableArrows;
    const handlePrevClick = useCallback((e)=>handleScrollBtnClick(e, 'previous'), [
        handleScrollBtnClick
    ]);
    const handleNextClick = useCallback((e)=>handleScrollBtnClick(e, 'next'), [
        handleScrollBtnClick
    ]);
    return /*#__PURE__*/ React.createElement(LazyContext.Provider, {
        value: true
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], overflow && s[`overflow-${overflow}`], slimSpacing && s['slim-spacing'], noSpacing && s['no-spacing'], permArrows && s['perm-arrows'], stableWidthButtons && s['stable-width-buttons'], className),
        style: {
            height
        },
        ref: rootRef,
        "data-hook": dataHook
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "Slider"
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['content'], disableScroll && s['no-scroll'], scrollSnap && s['scroll-snap'], contentClassName),
        ref: contentRef,
        draggable: "false"
    }, children), withControls && /*#__PURE__*/ React.createElement(React.Fragment, null, renderPrevButton ? renderPrevButton({
        onClick: handlePrevClick,
        className: s['custom-prev-btn']
    }) : /*#__PURE__*/ React.createElement(DefaultPreviousButton, {
        onClick: handlePrevClick
    }), renderNextButton ? renderNextButton({
        onClick: handleNextClick,
        className: s['custom-next-btn']
    }) : /*#__PURE__*/ React.createElement(DefaultNextButton, {
        onClick: handleNextClick
    })))));
};
Slider.displayName = 'Slider';
export default Slider;
